import { fileUtils } from '@/shared/lib/file/download';
import type { AttachmentSummary, LocalAttachment } from '../model/types';

/**
 * Downloads an attachment - handles both local and server files
 */
export const downloadAttachment = async (
  attachment: AttachmentSummary | LocalAttachment,
  downloadFn?: (attachmentId: number) => Promise<Blob>
): Promise<void> => {
  if ('file' in attachment && attachment.file) {
    fileUtils.downloadFile(attachment.file, attachment.file.name);
    return;
  }

  if (!('id' in attachment) || !attachment.id || !downloadFn) {
    throw new Error('Cannot download: missing attachment id or download function');
  }

  const blob = await downloadFn(attachment.id);
  const fileName = attachment.fileName || 'download';

  fileUtils.downloadFile(blob, fileName);
};
